import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=7c7d5a52&scoped=true&"
import script from "./FAQ.vue?vue&type=script&lang=js&"
export * from "./FAQ.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/faq.scss?vue&type=style&index=0&id=7c7d5a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7d5a52",
  null
  
)

export default component.exports